<template>
    <div class="col-12 text-left">
        <h3 class="align-left">
            <small class="text-muted">Service Order</small>
        </h3>
        <div class="dropdown-divider"></div><br />
        <app-data-search v-on:searching="search"></app-data-search>
        <button type="button" class="btn btn-outline-info" @click="view">View <i class="far fa-edit"></i></button>
        <br /><br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="so" v-on:selectedRow="selectRow"></app-datatable>
        <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
    </div>
</template>


<script>
import api from '../../services/api'
import { ServiceOrder } from '../../models/serviceOrder'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch
    },
    data() {
        return {
            so: [ServiceOrder],
            dtElements: [
                {
                    title: 'No. Order',
                    column: 'serviceNo'
                },
                {
                    title: 'Tanggal',
                    column: 'date',
                    type: 'date'
                },
                {
                    title: 'Name',
                    column: 'name'
                },
                {
                    title: 'Phone',
                    column: 'phoneNumber'
                },
                {
                    title: 'Email',
                    column: 'email'
                },
                {
                    title: 'Kode Servis',
                    column: 'serviceCode'
                },
                {
                    title: 'Nama Servis',
                    column: 'serviceName'
                },
                {
                    title: 'Status Konfirmasi',
                    column: 'isConfirm'
                },
            ],
            selectedId: '',
            searchKey: '',
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    async created() {
        this.init()
    },
    methods : {
        async init() {
            const soApi = api('service-order/pagination')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            this.so = await soApi.getWithQuery(query) 
        },
        view() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'appServiceOrderDetail',
                    query: {
                        id: this.selectedId
                    }
                })
            } else {
                alert('hahahh')
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        }
    }
}
</script>
